/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ActivityChannelOrientationConfiguration { 
    x?: ActivityChannelOrientationConfiguration.XEnum;
    y?: ActivityChannelOrientationConfiguration.YEnum;
    z?: ActivityChannelOrientationConfiguration.ZEnum;
}
export namespace ActivityChannelOrientationConfiguration {
    export const XEnum = {
        Channel1: 'CHANNEL_1',
        Channel2: 'CHANNEL_2',
        Channel3: 'CHANNEL_3'
    } as const;
    export type XEnum = typeof XEnum[keyof typeof XEnum];
    export const YEnum = {
        Channel1: 'CHANNEL_1',
        Channel2: 'CHANNEL_2',
        Channel3: 'CHANNEL_3'
    } as const;
    export type YEnum = typeof YEnum[keyof typeof YEnum];
    export const ZEnum = {
        Channel1: 'CHANNEL_1',
        Channel2: 'CHANNEL_2',
        Channel3: 'CHANNEL_3'
    } as const;
    export type ZEnum = typeof ZEnum[keyof typeof ZEnum];
}


export type XEnum = typeof ActivityChannelOrientationConfiguration.XEnum[keyof typeof ActivityChannelOrientationConfiguration.XEnum];
export type YEnum = typeof ActivityChannelOrientationConfiguration.YEnum[keyof typeof ActivityChannelOrientationConfiguration.YEnum];
export type ZEnum = typeof ActivityChannelOrientationConfiguration.ZEnum[keyof typeof ActivityChannelOrientationConfiguration.ZEnum];
